/*
 * Module for an engine item
 */
define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/accountAdmin/engineAdminModal/engineAdminModalView",
], function (Marionette, $, Messenger, EngineAdminModalView) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "engineItem";
      this.region = options.region;
      this.editMode = options.editMode;
    },
    show: function (engine) {
      this.engine = engine;
      this.engine.editMode = this.editMode;
      this.view = new EngineAdminModalView.engineAdminModalView({
        model: this.engine,
      });

      this.engine.backup();

      //handle bad save
      engine.on(
        "invalid",
        function (model, error) {
          //Clear errors first
          this.view.clearErrors();
          if ("engineName" in error) {
            this.view.engineNameError(error["engineName"]);
          }
          if ("engineDescription" in error) {
            this.view.engineDescriptionError(error["engineDescription"]);
          }
          if ("soapDomain" in error) {
            this.view.soapDomainError(error["soapDomain"]);
          }
          if ("kbCapacity" in error) {
            this.view.capacityError(error["kbCapacity"]);
          }
          if ("internalUrl" in error) {
            this.view.internalUrlError(error["internalUrl"]);
          }
        },
        this,
      );

      this.view.on(
        "done",
        function () {
          //save model
          engine.set("engineName", this.view.getEngineName());
          engine.set("engineDescription", this.view.getEngineDescription());
          engine.set("soapDomain", this.view.getSoapDomain());
          engine.set("kbCapacity", {
            capacity: this.view.getKbCapacity(),
            usage: engine.isNew() ? 0 : engine.get("kbCapacity").usage,
          });
          engine.set("internalUrl", this.view.getInternalUrl());

          if (Messenger.reqres.request("save:textbox")) {
            engine.saveModel({
              success: () => {
                engine.dirty = false;
                Messenger.vent.trigger("close:modal");
              },
              error: (model, response) => {
                if (response.status === 400) {
                  if (this.editMode === true) {
                    Messenger.okDialog(
                      $.t("admin.engineAdmin.updateError", {
                        message: response.responseJSON.value,
                      }),
                    );
                  } else {
                    Messenger.okDialog(
                      $.t("admin.engineAdmin.addError", { message: response.responseJSON.value }),
                    );
                  }
                } else {
                  Messenger.showErrorFromResponse(response);
                }
              },
            });
          }
        },
        this,
      );

      this.view.on(
        "cancel",
        function () {
          //if item is new, delete it
          if (engine.isNew()) {
            engine.deleteModel();
          } else {
            engine.restore();
          }
          Messenger.vent.trigger("close:modal");
        },
        this,
      );

      this.showRegion(this.view);
    },
  });
});
